import { Combobox } from '@headlessui/react'
import parseClassNames from 'classnames'
import {
  ChangeEvent,
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ManagerApi from 'shared/api/manager/Api'
import BaseInput from 'shared/components/base/form/base-input'
import useDebounce from 'shared/hooks/use-debounce'
import {
  setNewLeadName,
  setSelectedCustomer,
} from 'store/slice/call-detail/call-detail.slice'
import { SelectedCustomerType } from 'store/slice/call-detail/types'
import { RootState } from 'store/store'

import CustomerSearchInputOptions from './customer-search-input-options'

export default function CustomerSearchInput(props: {
  label?: any
  inputClassName?: string
  isNew: boolean
  setIsNew: Dispatch<SetStateAction<boolean>>
  onSelect?: (value: SelectedCustomerType | undefined) => void
  value?: SelectedCustomerType
  onChangeInput?: (event: ChangeEvent<HTMLInputElement>) => void
}) {
  const { isNew, setIsNew, onSelect, value, onChangeInput } = props
  const dispatch = useDispatch()
  const { selectedCustomer } = useSelector(
    (state: RootState) => state.callDetail.formData
  )
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [searchedText, setSearchedText] = useState<string>('')
  const [options, setOptions] = useState<SelectedCustomerType[]>([])

  useEffect(() => {
    if (value?.name) setSearchedText(value?.name)
  }, [value])

  const NewBadge = () => (
    <div
      style={{
        background:
          'linear-gradient(90deg, rgba(185, 249, 135, 0.15) 0%, rgba(128, 240, 110, 0.15) 100%)',
      }}
      className="flex items-center justify-center px-3 rounded"
    >
      <p className="leading-8 text-xs font-medium text-[#107715]">جدید</p>
    </div>
  )

  useDebounce(
    () => {
      setIsLoading(true)
      ManagerApi?.salesPersons
        ?.searchInClientsList({
          Search: searchedText ? searchedText : undefined,
        })
        .then((res) => {
          // return res.data

          const data = res.data
          setOptions(() => {
            return [
              ...(data?.contacts?.map((contact) => ({
                type: 'contact',
                id: contact.id || '',
                name: contact.name,
                companyName: contact.accountName,
              })) || []),
              ...(data?.accounts?.map((account) => ({
                type: 'account',
                id: account.id,
                name: account.name,
              })) || []),
              ...(data?.leads?.map((lead) => ({
                type: 'lead',
                id: lead.id,
                name: lead.name,
                companyName: lead.companyName,
              })) || []),
            ] as SelectedCustomerType[]
          })

          setIsLoading(false)
        })
    },
    0,
    [searchedText]
  )

  function search(value: string) {
    setSearchedText(value)
  }

  useEffect(() => {
    if (selectedCustomer) {
      setIsNew(false)
    }
  }, [selectedCustomer])

  useEffect(() => {
    if (isNew) {
      if (selectedCustomer) {
        dispatch(setNewLeadName(selectedCustomer.name))
      } else {
        dispatch(setNewLeadName(searchedText))
      }
    } else {
      dispatch(setNewLeadName(''))
    }
  }, [isNew, searchedText])

  return (
    <Combobox
      onChange={(value) => {
        if (onSelect) {
          onSelect(value)
        } else {
          dispatch(setSelectedCustomer(value))
        }
      }}
      value={selectedCustomer}
      as="div"
      className="relative col-span-5"
      inputMode="text"
    >
      {({ open }) => (
        <>
          <Combobox.Input
            as={BaseInput}
            label={props?.label ? props?.label : undefined}
            displayValue={() =>
              value?.name ? value?.name : selectedCustomer?.name || searchedText
            }
            value={searchedText}
            inputClassName={parseClassNames(
              isNew ? 'pl-9' : '',
              'bg-white h-10',
              props?.inputClassName || undefined
            )}
            onChange={(event) => {
              onChangeInput ? onChangeInput(event) : null
              if (event.target.value.includes('*')) {
                event.target.value = event.target.value.replace('*', '')
                document.getElementById('search-operator')?.focus()
                return
              }
              search(event.target.value)
              dispatch(setSelectedCustomer(undefined))
            }}
            // trailingIcon={() => <div className="hidden" />}
            leadingIcon={isNew ? NewBadge : undefined}
          />
          <Combobox.Button className="absolute  right-2 bottom-[0.875rem] flex items-center cursor-pointer">
            {/*<SelectorIcon*/}
            {/*  className="w-5 h-5 text-gray-light "*/}
            {/*  aria-hidden="true"*/}
            {/*/>*/}
          </Combobox.Button>
          <CustomerSearchInputOptions
            isOpen={open}
            isLoading={isLoading}
            options={options}
            setIsNew={setIsNew}
          />
        </>
      )}
    </Combobox>
  )
}
